
import React from 'react'
import moment from "moment";
const json = {
    vte_id:"",
    vte_patient_id:"",
    vte_admission_id:"",
    vte_admission_date:"",
    vte_assessment_date:"",
    vte_bmi:"",
    vte_malignancy:"",
    vte_abnormal_coagulation:"",
    vte_history_of_thromboembolism:"",
    vte_ais_head:"",
    vte_ais_chest:"",
    vte_ais_abdomen:"",
    vte_gcs_score:"",
    vte_complex_lower:"",
    vte_pelvic_fracture:"",
    vte_femoral_central:"",
    vte_transfusion:"",
    vte_surgical_procedure:"",
    vte_repair_ligation:"",
    vte_age40year:"",
    vte_age60year:"",
    vte_age75year:"",
    vte_grs_risk:"",
    vte_grs_hospitalized:"",
    vte_grs_confinedtobed:"",
    vte_grs_intoxication:"",
    vte_grs_restraints:"",
    vte_grs_no_indication:"",
    vte_grs_enoxaparin:"",
    vte_grs_heparin:"",
    vte_grs_presented:"",
    vte_grs_sequential:"",
    vte_grs_bleeding:"",
    vte_hemodynamic_instability:"",
    vte_grs_traumatic:"",
    vte_grs_spinal_cord:"",
    vte_grs_pharmacological_date:"",
    vte_grs_pharmacological : "",
    vte_summary_regimen:"",
    vte_summary_regimen_other:"",
    vte_complication_of_anticoagulant:"",
    vte_complication_of_anticoagulant_remark:"",
    vte_scd:"",
    vte_scd_date:"",
    vte_active_bleeding:"",
    vte_hemoglobin_drop:"",
    vte_ongoing_blood_transfusion:"",
    vte_pt:"",
    vte_platelet_count:"",
    vte_grade:"",
    vte_traumatic_brain_Injury:"",
    vte_intracerebral_hemorrhage:"",
    vte_ICH:"",
    vte_progrssion:"",
    vte_presented:"",
    vte_spinal_injury:"",
    vte_no_operation:"",
    vte_plan_operation_with24:"",
    vte_plan_operation_over24:"",
    vte_duplex_us:"",
    vte_duplex_us_remark:"",
    vte_dvt:"",
    vte_presented_dvt:"",
    vte_presented_dvt_remark:"",
    vte_throbbing_cramping : "",
    vte_swell : "",
    vte_warm_skin : "",
    vte_reddarkened :  "",
    vte_dyspnea :  "",
    vte_chest_pain  : "",
    vte_hemoptysis : "",
    vte_syncope  : "",
    vte_tachycardia  : "",
    vte_tachypnea : "",
    vte_decrease : "",
    vte_jugular  : "",
    vte_decreaseO : "",
    vte_sqt_ecg :  "",
    vte_summary_need : "",
    vte_summary_need_date : "",
    vte_summary_regimen_enoxaparin_heparin: "",
    vte_summary_regiment_remark : "",
    vte_summary_complication :"",
    vte_summary_complication_remark : "",
    vte_summary_sequential : "",
    vte_summary_sequential_date : "",
    vte_sleep_part2 : 0,
    vte_sleep_part3 : 0,
    name: '',
    surname: '',
    hn: '',
    blood_group: '',
    rh: '',
    gender: '',
    point : 0
}

export default json;
